import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'info-tag',
  styleUrl: 'info-tag.scss',
  shadow: false,
  scoped: false
})
export class InfoTag {
  @Prop() public heading: string;
  @Prop() public content: string;

  private deserialiseContent(): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = this.content;
    return txt.value;
  }

  private renderContent(): any {
    return <div innerHTML={this.deserialiseContent()} />;
  }

  render(): any {
    return (
      <Host>
        <div class="info-tag-container">
          <div class="info-tag-title">{this.heading}</div>
          <div class="info-tag-content">{this.renderContent()}</div>
        </div>
      </Host>
    );
  }
}
